import { Component } from '@angular/core'

@Component({
  selector: 'payment-methods',
  imports: [],
  templateUrl: './payment-methods.component.html',
  styleUrl: './payment-methods.component.scss',
  standalone: true,
})
export class PaymentMethodsComponent {}
